import React, { Component, Fragment } from 'react';
import { Table, Card, Tooltip, Icon, Tag, Avatar, Button, Switch, Badge } from 'antd';
import { inject, observer } from 'mobx-react/index';
import moment from 'moment-timezone';
import { withRouter } from 'react-router-dom';

@inject('store')
@withRouter
@observer
export class PositionHistoryView extends Component {
    constructor(props) {
        super(props);
        this.state = { showCancelled: false };
    }

    async componentDidMount() {
        this.props.store.botStore.positionStore.getHistory(false);
    }

    render() {
        const timezone = this.props.store.userStore.currentUser.timezone;

        const schema = [
            {
                title: '',
                dataIndex: 'source',
                key: 'source',
                render(text, o) {
                    switch (o.source) {
                        case 'mh':
                        case 'cbs':
                        case 'TV':
                            return (
                                <Tooltip title={`Group: ${o.group || 'None'}`}>
                                    <Avatar
                                        alt={`signal source ${o.source} logo`}
                                        src={`/signals/${o.source}.png`}
                                    />
                                </Tooltip>
                            );

                        default:
                            return null;
                    }
                }
            },

            {
                title: '',
                dataIndex: 'icon',
                key: 'icon',
                render(text, o) {
                    const iconstyle = { fontSize: 24 };
                    const taEnabled =
                        o.sell_strategy_config && o.sell_strategy_config.ta_enabled ? (
                            <span>
                                <Icon type="stock" className={'success'} style={iconstyle} />
                            </span>
                        ) : null;

                    let adca = o.auto_dca_enabled ? (
                        <Icon type="safety" className={'success'} style={iconstyle} />
                    ) : (
                        <Icon type="safety" className={'error'} style={iconstyle} />
                    );

                    if (o.auto_dca_error)
                        adca = (
                            <Tooltip
                                title={'Auto DCA: error detected check the journal for details'}
                            >
                                <Icon type="warning" style={iconstyle} className={'error'} />
                            </Tooltip>
                        );
                    if (o.auto_dca_scanning)
                        adca = <Icon type="safety" style={{ ...iconstyle, color: '#ffd841' }} />;

                    let artDelta = null;
                    if (o.rt_auto_sell_price) {
                        const value =
                            ((o.rt_auto_sell_price - o.avg_buy_price) / o.avg_buy_price) * 100;
                        artDelta = (
                            <span>
                                Auto Sell: {o.rt_auto_sell_price.toFixed(8)} {value.toFixed(2)}%
                            </span>
                        );
                    }
                    let art = o.auto_reverse_enabled ? (
                        <Tooltip title={artDelta}>
                            <Icon type="fund" className={'success'} style={iconstyle} />
                        </Tooltip>
                    ) : (
                        <Icon type="fund" className={'error'} style={iconstyle} />
                    );
                    return (
                        <span>
                            {taEnabled}&nbsp;
                            <Badge count={o.auto_dca_level || 0}>{adca}</Badge>&nbsp;
                            <Badge count={o.auto_rt_level || 0}>{art}</Badge>
                        </span>
                    );
                }
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                render(text, o) {
                    if (text === 'COMPLETE') {
                        const value = o.result > 0;
                        return <Tag color={value ? '#29c0b1' : '#ff3366'}>{text}</Tag>;
                    }
                    return <Tag>{text}</Tag>;
                }
            },
            {
                title: 'Symbol',
                dataIndex: 'base',
                key: 'base',
                sorter: (a, b) => {
                    if (a.base < b.base) return -1;
                    if (a.base > b.base) return 1;
                    return 0;
                },
                render: (text, position) => {
                    return (
                        <a
                            onClick={() =>
                                window.open(
                                    `https://uk.tradingview.com/chart?symbol=binance%3A${position.baseId}${position.quoteId}`,
                                    '_blank'
                                )
                            }
                        >
                            <Avatar width={'24px'} src={`/symbols/${text}.png`} /> {text}
                        </a>
                    );
                }
            },
            {
                title: 'Ordered/Filled/Held',
                dataIndex: 'bought',
                key: 'bought',
                sorter: (a, b) =>
                    parseFloat(a.quantity_filled || 0) - parseFloat(b.quantity_filled || 0),
                render: (text, record) => {
                    let icon = null;

                    if (record.quantity_filled !== record.sold_quantity) {
                        const dustValue =
                            (record.quantity_filled - record.sold_quantity) * record.close_price;
                        icon = (
                            <Tooltip placement="top" title={`${dustValue.toFixed(8)} dust left`}>
                                <Icon type="warning" theme="outlined" />
                            </Tooltip>
                        );
                    }

                    return (
                        <span>
                            {icon} {(record.amount_ordered || 0).toFixed(3)} /{' '}
                            {(record.amount_filled || 0).toFixed(3)} /{' '}
                            {(record.amount_held || 0).toFixed(3)}
                        </span>
                    );
                }
            },
            {
                title: 'Purchase Price',
                dataIndex: 'price',
                key: 'price',
                render: (text, o) => {
                    if (text) {
                        return text.toFixed ? text.toFixed(8) : text;
                    }
                    return '0';
                }
            },
            {
                title: 'Total Cost ',
                dataIndex: 'max_cost',
                key: 'max_cost',
                sorter: (a, b) => {
                    return a.max_cost - b.max_cost;
                },
                render: (text, o) => {
                    return (o.max_cost || 0).toFixed(8);
                }
            },
            {
                title: 'Close Price',
                dataIndex: 'current_price',
                key: 'current_price',
                render: text => (text ? text.toFixed(8) : '-')
            },
            {
                title: 'Result w/fees',
                dataIndex: 'result',
                key: 'result',
                sorter: (a, b) => {
                    return (a.result || 0) - (b.result || 0);
                },
                render: (text, record) => {
                    let kpi = '';

                    if (record.status !== 'REVERSING' && record.rt_last_buy_price) {
                        kpi =
                            ((record.current_price - record.rt_last_buy_price) /
                                record.rt_last_buy_price) *
                            100;
                        if (kpi >= 0) {
                            kpi = (
                                <span className="success">
                                    <br />
                                    <Tooltip
                                        title={`Result from buy price (${record.rt_last_buy_price})`}
                                    >
                                        <Icon type="fund" /> {kpi.toFixed(2)}%{' '}
                                    </Tooltip>
                                </span>
                            );
                        } else {
                            kpi = (
                                <span className="error">
                                    <br />
                                    <Tooltip
                                        title={`Result from buy price (${record.rt_last_buy_price})`}
                                    >
                                        <Icon type="fund" /> {kpi.toFixed(2)}%{' '}
                                    </Tooltip>
                                </span>
                            );
                        }
                    }
                    if (!record.result_w_fees) {
                        const result =
                            ((record.close_price - record.price_buy_avg) / record.price_buy_avg) *
                            100;
                        if (result > 0)
                            return (
                                <Fragment>
                                    <span className="success">{result.toFixed(2)}% </span>
                                </Fragment>
                            );
                        if (result < 0)
                            return (
                                <Fragment>
                                    <span className="error">{result.toFixed(2)}% </span>
                                </Fragment>
                            );
                        if (result === 0)
                            return (
                                <Fragment>
                                    <span>{result.toFixed(2)}% </span>
                                </Fragment>
                            );
                    }

                    const value = record.result_w_fees;
                    if (value > 0)
                        return (
                            <Fragment>
                                <span className="success">{value.toFixed(2)}% </span>
                                {kpi}
                            </Fragment>
                        );
                    if (value < 0)
                        return (
                            <Fragment>
                                <span className="error">{value.toFixed(2)}% </span>
                                {kpi}
                            </Fragment>
                        );
                    if (value === 0)
                        return (
                            <Fragment>
                                <span>{value.toFixed(2)}% </span>
                                {kpi}
                            </Fragment>
                        );
                }
            },
            {
                title: 'Exposure',
                dataIndex: 'exposure',
                key: 'exposure',
                sorter: (a, b) => {
                    const anow = moment(a.created_at); //todays date
                    const aend = moment(a.closed_at); // another date
                    const bnow = moment(b.created_at); //todays date
                    const bend = moment(b.closed_at); // another date
                    return moment.duration(aend.diff(anow)) - moment.duration(bend.diff(bnow));
                },
                render: (text, record) => {
                    const now = moment.utc(record.created_at); //todays date
                    const end = moment.utc(record.closed_at); // another date
                    const duration = moment.duration(end.diff(now));
                    return duration.humanize();
                }
            },
            {
                title: 'Closed At',
                dataIndex: 'closed_at',
                key: 'closed_at',
                sorter: (a, b) => {
                    return a.closed_at - b.closed_at;
                },
                render: (text, record) => {
                    return record.closed_at
                        ? moment(record.closed_at)
                              .tz(timezone)
                              .format('DD/MM/YYYY hh:mm:ss a')
                        : '-';
                }
            }
        ];

        return (
            <div>
                <Card
                    title={'History'}
                    bordered={false}
                    extra={
                        <Button
                            onClick={() => {
                                const header = [
                                    [
                                        'id',
                                        'base_id',
                                        'quote_id',
                                        'link',
                                        'status',
                                        'buy_price',
                                        'filled',
                                        'sold',
                                        'close_price',
                                        'fees',
                                        'pl_w_fees',
                                        'strategy',
                                        'created_at',
                                        'closed_at',
                                        ','
                                    ]
                                ];
                                const rows = this.props.store.botStore.positionStore.history
                                    .filter(p => {
                                        return p.status === 'COMPLETE' && !this.state.showCancelled
                                            ? true
                                            : this.state.showCancelled;
                                    })
                                    .map(position => {
                                        return [
                                            position.id,
                                            position.baseId,
                                            position.quoteId,
                                            `https://uk.tradingview.com/chart?symbol=binance%3A${position.baseId}${position.quoteId}`,
                                            position.status,
                                            position.price,
                                            position.amount_filled,
                                            position.amount_sold,
                                            position.close_price,
                                            position.fee_total_in_base,
                                            position.pl_w_fees,
                                            position.strategy_name,
                                            moment(position.created_at).format(
                                                'DD/MM/YYYY hh:mm:ss a'
                                            ),
                                            moment(position.closed_at).format(
                                                'DD/MM/YYYY hh:mm:ss a'
                                            )
                                        ];
                                    });
                                const csvContent = [...header, ...rows].join('\n');

                                let pom = document.createElement('a');
                                const blob = new Blob([csvContent], {
                                    type: 'text/csv;charset=utf-8;'
                                });
                                const url = URL.createObjectURL(blob);
                                pom.href = url;
                                pom.download = `apex-position-export-${Date.now()}.csv`;
                                pom.click();
                            }}
                        >
                            Download
                        </Button>
                    }
                    size={'small'}
                >
                    <div style={{ marginBottom: 15 }}>
                        <Switch
                            onChange={checked => {
                                this.props.store.botStore.positionStore.getHistory(checked);
                            }}
                        />{' '}
                        Show Cancelled/Expired
                    </div>

                    <Table
                        size="small"
                        dataSource={this.props.store.botStore.positionStore.history}
                        rowKey="id"
                        scroll={{ x: 1000 }}
                        expandRowByClick
                        pagination={{
                            defaultPageSize: 25,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '25', '50', '100']
                        }}
                        expandedRowRender={position =>
                            this.props.history.push(
                                `/a/bot/${this.props.match.params.id}/position/${position.id}`
                            )
                        }
                        columns={schema}
                    />
                </Card>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionHistoryView/index.js